import { useMemo } from "react";

import type { Comment } from "./useComments";
import { useProjectViewLinks } from "./useProjectViewLink";
import { useViewLinkId } from "./useWebExport";

export const useCommentVersion = () => {
  const viewLinkId = useViewLinkId();

  const { viewLinks } = useProjectViewLinks();

  const viewLinkRevisionById = useMemo(() => {
    const map = new Map<string, number>();
    viewLinks.forEach((viewLink) => {
      map.set(viewLink.projectViewLinkId, viewLink.revisionId);
    });
    return map;
  }, [viewLinks]);

  const selectedViewLinkRevisionId = useMemo(() => {
    if (!viewLinkId) return undefined;
    return viewLinkRevisionById.get(viewLinkId);
  }, [viewLinkId, viewLinkRevisionById]);

  const isNewerVersion = useMemo(() => {
    return (comment: Comment) => {
      const commentRevisionId = viewLinkRevisionById.get(comment.projectViewLinkId);
      if (!commentRevisionId || !selectedViewLinkRevisionId) return false;
      return commentRevisionId > selectedViewLinkRevisionId;
    };
  }, [selectedViewLinkRevisionId, viewLinkRevisionById]);

  return { isNewerVersion };
};
